/*!
 * is-valid-path <https://github.com/jonschlinkert/is-valid-path>
 *
 * Copyright (c) 2015 Jon Schlinkert, contributors.
 * Licensed under the MIT license.
 */

'use strict';

var isInvalidPath = require('is-invalid-path');

module.exports = function (str) {
  return isInvalidPath(str) === false;
};



//////////////////
// WEBPACK FOOTER
// ./~/is-valid-path/index.js
// module id = 50
// module chunks = 0